// block options: center, end, nearest, start
// behavior options: auto, smooth
export const scrollTo = (value) => {
    document.getElementById(value)?.scrollIntoView({behavior: 'smooth', block: 'start'});
};
